/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PortfolioInputs */

const et_nav_portfolio = /** @type {(inputs: Nav_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfoolio`)
};

const en_nav_portfolio = /** @type {(inputs: Nav_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio`)
};

/**
* | output |
* | --- |
* | "Portfolio" |
*
* @param {Nav_PortfolioInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_portfolio = /** @type {((inputs?: Nav_PortfolioInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PortfolioInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_portfolio(inputs)
	return en_nav_portfolio(inputs)
});